export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6418.be2cd0e2.jpg";